import type {Result, UseCase} from 'framework';
import type {Product} from '../../domain/product';
import type {ProductError} from '../../domain/errors';
import type {ProductRepository, UpdateProductInput} from '../ports/product.repository';

export class UpdateProduct implements UseCase<[UpdateProductInput], Product> {
  constructor(private readonly repository: ProductRepository) {}

  execute(input: UpdateProductInput): Promise<Result<Product, ProductError>> {
    return this.repository.update(input);
  }
}
